import ShipTypeService from "../../services/ShipTypeService";

export default {
  namespaced: true,
  state() {
    return {
      shipTypes: [],
    };
  },
  mutations: {
    setShipTypes(state, shipTypes) {
      state.shipTypes = shipTypes;
    },
  },
  actions: {
    async getShipTypes(context, data) {
      try {
        var res = await ShipTypeService.getShipTypes(data);
        //after real data come
        context.commit("setShipTypes", res.data);
      } catch (err) {
        console.error("Error fetching shipTypes:", err);
      }
    },
  },
  getters: {
    getShipTypes(state) {
      return state.shipTypes;
    },
    getShipTypesByStcode: (state) => (stcode) => {
      return state.shipTypes.find((shipType) => shipType.stcode === stcode);
    },
  },
};
